const PAYMENT_TYPE = {
  purchase: 1,
  instalments: 2,
  fundraising: 3,
  fundraisingDonate: 4
} as const

const PAYMENT_METHOD = {
  traditional: 1,
  online: 2
} as const

const PAYMENT_STATUS = {
  PENDING: 1,
  NOT_PAID: 2,
  INVALID: 3,
  PAID: 4,
  INSTALLMENT_CREATED: 5
} as const

const CHANGELOG_ACTION = {
  SET_PAYMENT_NOTE: 83
} as const

export { PAYMENT_TYPE, PAYMENT_METHOD, PAYMENT_STATUS, CHANGELOG_ACTION }
